import { ProAuctoreAndProFamiliaMissingDoctorContactDetails } from '../ProAuctoreAndProFamiliaMissingContactDetailsModal.types';

export const isPhoneNumberMissing = (missingDetails: ProAuctoreAndProFamiliaMissingDoctorContactDetails): boolean => {
   return (Array.isArray(missingDetails) && missingDetails.includes('phoneNumber')) || missingDetails === 'phoneNumber';
};

export const isAddressMissing = (missingDetails: ProAuctoreAndProFamiliaMissingDoctorContactDetails): boolean => {
   return (Array.isArray(missingDetails) && missingDetails.includes('address')) || missingDetails === 'address';
};
